import React from "react";
import module_style from "../Style.module.css";
import Dots from "@material-ui/icons/DragIndicator";
import PropTypes from "prop-types";
import { useDispatch, useSelector } from "react-redux";
import { EXLY_WEBPAGE_DETAILS__REFETCH_LISTINGS } from "ui/pages/TemplatePreview/redux/actions";
import RemoveCircleOutlined from "@material-ui/icons/RemoveCircleOutlined";
import api from "data/APIs";
import { WebpageCreationContext } from "ui/pages/TemplatePreview";
import { is_empty } from "utils/validations";
import dataProvider from "data/dataProvider";

const ListingCard = ({ item, index, provided, can_remove_keyword }) => {
  const dispatch = useDispatch();
  const selected_keyword = useSelector(
    (state) => state.webpage_detail.selected_keyword
  );

  const { pushNotif } = React.useContext(WebpageCreationContext);

  const removeKeyword = async () => {
    try {
      if (!is_empty(item) && !is_empty(selected_keyword?.uuid)) {
        const status = await dataProvider.custom_request(
          item.listing_id
            ? api.remove_keyword_listing
            : api.remove_keyword_plan,
          "POST",
          {
            keyword_uuid: selected_keyword.uuid,
            entity_uuid: item.listing_id ? item.listing_id : item.plan_uuid,
          }
        );
        if (status.status === 200) {
          dispatch({ type: EXLY_WEBPAGE_DETAILS__REFETCH_LISTINGS });
          pushNotif(status.message);
        }
      }
    } catch (err) {
      console.log("removeKeyword err", err);
      pushNotif(
        err?.body?.message ? err?.body?.message : "Something went wrong"
      );
    }
  };

  return (
    <div className={`${module_style.card}`}>
      <div style={{ display: "flex", alignItems: "center" }}>
        <div className={``}>
          <img
            src={
              item.side_image
                ? item.side_image
                : "https://www.solidbackgrounds.com/images/2560x1440/2560x1440-davys-grey-solid-color-background.jpg"
            }
            className={`${module_style.listing_image}`}
            alt={`side_image_${index}`}
          />
        </div>
        <div className={`left_margin ${module_style.listing_info}`}>
          <div className={`${module_style.sub_heading} line_max_1`}>
            {item.heading}
          </div>
          <div className={`${module_style.sub_heading} line_max_1 action_text`}>
            {item.desc}
          </div>
        </div>
        {/* {handleAddKeyword && <div onClick={() => {
                    dispatch({ type: EXLY_WEBPAGE_DETAILS__SET_SELECTED_ENTITY, payload: item });
                    handleAddKeyword(true)
                }} className="m-1 pointer"><AddCircleOutlinedIcon style={{ fill: '#493AB1' }} /></div>} */}
        {can_remove_keyword && (
          <div onClick={removeKeyword} className="m-1 pointer">
            <RemoveCircleOutlined style={{ fill: "#C21717" }} />
          </div>
        )}
        {provided && (
          <div
            className="m-1"
            style={{ cursor: "grab" }}
            {...provided.dragHandleProps}
          >
            <Dots fill="black" />
          </div>
        )}
      </div>
    </div>
  );
};

ListingCard.propTypes = {
  provided: PropTypes.object,
  item: PropTypes.object,
  index: PropTypes.number,
  handleAddKeyword: PropTypes.func,
  can_remove_keyword: PropTypes.bool,
};

export default ListingCard;
